import { Card, CardBody } from "reactstrap"
import BikroyIcon from "components/Common/BikroyIcon"
import TiktokIcon from "components/Common/TiktokIcon"
import { useWindowSize } from "hooks/useWindowSize"

const VehicleContentSidebar = ({ data, params, updateParams, isOpen, onClose }) => {
  const { width } = useWindowSize()
  const isMobile = width < 768

  const platformList = (
    <ul className="list-unstyled mb-0">
      {data?.length ? (
        data.map((item, index) => {
          const isActive = params?.slug === item?.slug
          const IconComponent =
            item.slug === "tiktok"
              ? TiktokIcon
              : item.slug === "bikroy"
              ? BikroyIcon
              : null

          return (
            <li key={index} className="mb-1">
              <button
                type="button"
                onClick={() => {
                  updateParams(prev => ({ ...prev, slug: item.slug, page: 1 }))
                  onClose?.()
                }}
                className="d-flex align-items-center w-100 border-0 py-2 px-3 rounded text-start"
                style={{
                  background: isActive ? "#556ee6" : "transparent",
                  color: isActive ? "#fff" : "inherit",
                  fontWeight: isActive ? 600 : 400,
                  transition: "background 0.15s ease, color 0.15s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={e => {
                  if (!isActive) e.currentTarget.style.background = "#f3f4f8"
                }}
                onMouseLeave={e => {
                  if (!isActive) e.currentTarget.style.background = "transparent"
                }}
              >
                <span className="me-2 d-flex align-items-center flex-shrink-0">
                  {IconComponent ? (
                    <IconComponent
                      width={18}
                      height={18}
                      style={{ filter: isActive ? "brightness(0) invert(1)" : "none" }}
                    />
                  ) : (
                    <i
                      className={`font-size-16 ${item.icon || ""}`}
                      style={{ color: isActive ? "#fff" : "inherit" }}
                    />
                  )}
                </span>
                <span className="me-auto text-truncate">{item.platform_name}</span>
                {item.total_pending !== undefined && (
                  <span
                    className="badge rounded-pill ms-2 flex-shrink-0"
                    style={{
                      background: isActive ? "rgba(255,255,255,0.25)" : "#556ee6",
                      color: "#fff",
                      fontSize: "0.7rem",
                    }}
                  >
                    {item.total_pending}
                  </span>
                )}
              </button>
            </li>
          )
        })
      ) : (
        <li className="text-muted small px-3 py-2">No platforms available.</li>
      )}
    </ul>
  )

  const sidebarHeader = (
    <div className="d-flex justify-content-between align-items-center px-3 pt-3 pb-2">
      <span
        className="text-uppercase fw-semibold"
        style={{ fontSize: "0.7rem", letterSpacing: "0.08em", color: "#74788d" }}
      >
        Platforms
      </span>
      {isMobile && (
        <button
          type="button"
          className="btn-close"
          style={{ fontSize: "0.65rem" }}
          aria-label="Close"
          onClick={onClose}
        />
      )}
    </div>
  )

  // ── Mobile: fixed slide-in drawer with backdrop ──────────────────────────
  if (isMobile) {
    return (
      <>
        {/* Backdrop */}
        <div
          onClick={onClose}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1040,
            background: "rgba(0,0,0,0.45)",
            opacity: isOpen ? 1 : 0,
            pointerEvents: isOpen ? "auto" : "none",
            transition: "opacity 0.25s ease",
          }}
        />

        {/* Drawer panel */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "230px",
            zIndex: 1041,
            overflowY: "auto",
            background: "#fff",
            boxShadow: "4px 0 20px rgba(0,0,0,0.18)",
            transform: isOpen ? "translateX(0)" : "translateX(-100%)",
            transition: "transform 0.25s cubic-bezier(0.4,0,0.2,1)",
          }}
        >
          {sidebarHeader}
          <div className="px-1 pb-3">{platformList}</div>
        </div>
      </>
    )
  }

  // ── Desktop: normal static card in the flex layout ───────────────────────
  return (
    <Card
      className="filemanager-sidebar flex-shrink-0"
      style={{ minWidth: "190px", maxWidth: "220px", width: "100%" }}
    >
      <CardBody className="p-0 pb-2">
        {sidebarHeader}
        <div className="px-1">{platformList}</div>
      </CardBody>
    </Card>
  )
}

export default VehicleContentSidebar
